import React, { useMemo } from 'react';
import {
  Box,
  Paper,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from '@mui/material';
import { createStyles, makeStyles } from '@material-ui/core/styles';

const steps = ['Build', 'Model', 'Export'];

interface CombineAudienceStepperProps {
  activeStep: number;
  setActiveStep: (step: number) => void;
  audienceName: string;
  isAudienceLoading: boolean;
  isGenerationCompleted: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      padding: '2rem',
      position: 'fixed',
      bottom: 0,
      width: '-webkit-fill-available',
      zIndex: 1000,
    },
    stepLabel: {
      '& > span > .Mui-active': {
        color: '#413762',
      },
    },
  })
);

const CombineAudienceStepper: React.FC<CombineAudienceStepperProps> = ({
  activeStep,
  setActiveStep,
  audienceName,
  isAudienceLoading,
  isGenerationCompleted,
}) => {
  const classes = useStyles();
  const isAudienceDefined = useMemo(() => {
    return audienceName;
  }, [audienceName]);

  const handleStepClick = (step: number) => {
    if (isAudienceLoading) return;
    if (step === 1 && !isAudienceDefined && !isAudienceLoading) return;
    if (step === 2 && !isGenerationCompleted) return;
    setActiveStep(step);
  };

  return (
    <Box sx={{ width: '100%', py: 1 }}>
      <Paper elevation={3} className={classes.container}>
        <Stepper nonLinear activeStep={activeStep}>
          {steps.map((label, index) => (
            <Step
              key={label}
              disabled={
                isAudienceLoading ||
                (index === 1 && !isAudienceDefined) ||
                (index === 2 && !isGenerationCompleted)
              }
            >
              <StepLabel
                className={classes.stepLabel}
                onClick={() => handleStepClick(index)}
                style={{
                  cursor:
                    isAudienceLoading ||
                    (index === 1 && !isAudienceDefined) ||
                    (index === 2 && !isGenerationCompleted)
                      ? 'not-allowed'
                      : 'pointer',
                }}
              >
                <Typography
                  variant='body1'
                  sx={{
                    fontWeight: activeStep === index ? 'bold' : 'normal',
                    color: activeStep === index ? '#413762' : 'grey.500',
                    fontFamily: 'Calibre-Regular,sans-serif',
                    fontSize: '18px',
                  }}
                >
                  {label}
                </Typography>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Paper>
    </Box>
  );
};

export default CombineAudienceStepper;
